import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import TranslateButton from "../../TranslateButton/TranslateButton";
import One from "../../../images/Strategic Pan/1.jpg";
import Two from "../../../images/Strategic Pan/2.jpg";
import Three from "../../../images/Strategic Pan/3.jpg";
import Four from "../../../images/Strategic Pan/4.jpg";
import Five from "../../../images/Strategic Pan/5.jpg";
import Six from "../../../images/Strategic Pan/6.jpg";
import Seven from "../../../images/Strategic Pan/7.jpg";
import Eight from "../../../images/Strategic Pan/8.jpg";
import Nine from "../../../images/Strategic Pan/9.jpg";
import Ten from "../../../images/Strategic Pan/10.jpg";
import Eleven from "../../../images/Strategic Pan/11.jpg";
import Twelve from "../../../images/Strategic Pan/12.jpg";
import Thirteen from "../../../images/Strategic Pan/13.jpg";
import Forteen from "../../../images/Strategic Pan/14.jpg";
import Fifteen from "../../../images/Strategic Pan/15.jpg";
import Sixteen from "../../../images/Strategic Pan/16.jpg";
import Seventeen from "../../../images/Strategic Pan/17.jpg";
import Eighteen from "../../../images/Strategic Pan/18.jpg";
import Nineteen from "../../../images/Strategic Pan/19.jpg";
import "../../../style/focusArea/strategicPlan.css";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const StrategicPlan = () => {
  useEffect(() => {
    document.title = `AshroyAngon | Strategic Plan`;
  }, []);

  const shareUrl = "https://ashroyangon.org/focusArea/strategic-plan";

  return (
    <>
      <Navbar />
      <TranslateButton />

      <div className="strategicPlan_section">
        {/* Header Background Part Start */}
        <div className="header_background">
          <div className="container wrapper">
            <h2>Strategic Plan</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div>
        {/* Header Background Part End */}

        <div className="strategicPlan_wrapper">
          <div className="container">
            <h2>Our Strategic Plan</h2>
            <div className="strategic_plan">
              <img src={One} loading="lazy" alt="" />
              <img src={Two} loading="lazy" alt="" />
              <img src={Three} loading="lazy" alt="" />
              <img src={Four} loading="lazy" alt="" />
              <img src={Five} loading="lazy" alt="" />
              <img src={Six} loading="lazy" alt="" />
              <img src={Seven} loading="lazy" alt="" />
              <img src={Eight} loading="lazy" alt="" />
              <img src={Nine} loading="lazy" alt="" />
              <img src={Ten} loading="lazy" alt="" />
              <img src={Eleven} loading="lazy" alt="" />
              <img src={Twelve} loading="lazy" alt="" />
              <img src={Thirteen} loading="lazy" alt="" />
              <img src={Forteen} loading="lazy" alt="" />
              <img src={Fifteen} loading="lazy" alt="" />
              <img src={Sixteen} loading="lazy" alt="" />
              <img src={Seventeen} loading="lazy" alt="" />
              <img src={Eighteen} loading="lazy" alt="" />
              <img src={Nineteen} loading="lazy" alt="" />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default StrategicPlan;
